export class TriggerMethodType {
    static Start = 1;
    static Stop = 2;
    static Pause = 3;
    static Resume = 4;
}

export class TriggerType {
    static Simple = 0;
    static Cron = 1;
}

export class TriggerConstants {
    static TriggerMethodTypeDataSource = [
        { value: TriggerMethodType.Start, label: 'Bắt đầu', labelStatus: 'Đang chạy', styleClass: 'start', confirmMessage: 'Bạn có muốn khởi động lịch trình này không?', confirmHeader: 'Xác nhận khởi động' },
        { value: TriggerMethodType.Stop, label: 'Dừng', labelStatus: 'Đã dừng', styleClass: 'stop', confirmMessage: 'Bạn có muốn dừng lịch trình này không?', confirmHeader: 'Xác nhận dừng' },
        { value: TriggerMethodType.Pause, label: 'Tạm dừng', labelStatus: 'Tạm dừng', styleClass: 'pause', confirmMessage: 'Bạn có muốn tạm dừng lịch trình này không?', confirmHeader: 'Xác nhận tạm dừng' },
        { value: TriggerMethodType.Resume, label: 'Tiếp tục', labelStatus: 'Tiếp tục', styleClass: 'resume', confirmMessage: 'Bạn có muốn tiếp tục lịch trình này không?', confirmHeader: 'Xác nhận tiếp tục' }
    ]

    static TriggerTypeDataSource = [
        { value: TriggerType.Simple, label: 'Simple Trigger' },
        { value: TriggerType.Cron, label: 'Cron Trigger' }
    ]
}
